/**
 * Created by anthony on 11/23/14.
 */
ismfast = angular.module('ismfast');
ismfast.filter('objectByKeyValFilter', function () {
    return function (input, filterKey, filterVal) {
        var filteredInput ={};
        angular.forEach(input, function(value, key){
            if(value[filterKey] && value[filterKey] !== filterVal){
                filteredInput[key]= value;
            }
        });
        return filteredInput;
    }});

